// import { AxiosRequestConfig } from '@/public/fetch/type'
import { cryptoInstance } from '@/public/fetch';
import { payApi2 } from '@/public/utils/basePath';
const baseURL = payApi2;
export const login = (params) => {
    return cryptoInstance.post('/v2/user/login', params, {
        baseURL: payApi2,
        isFormData: true
    });
};
/**
 * @query
 * code
 */
export const getWechatCodeInfo = (query) => {
    return cryptoInstance.get('/wechat/code_info', {
        baseURL: payApi2,
        params: query
    });
};
/**
 * 获取微信授权
 * @query
 * redirectURI
 * 返回一个url地址
 * */
export const getWechatAuth = (query) => {
    return cryptoInstance('/wechat/auth2', {
        params: query,
        baseURL: payApi2
    });
};
/**
 * 获取微信签名
 * @query
 * url
 * */
export const getWechatSignature = query => {
    return cryptoInstance.get(`/wechat/signature`, {
        baseURL: payApi2,
        params: query
    });
};
/**
 * 支付
 * @params
 * module
 *  OmoOperation("omoOperation")
 *  OnlineOperation("onlineOperation")
 *  SmartExercise("smartExercise")
 * @query
 * orderId
 * backUrl
 *
 */
export const getWechatSign = ({ params, query }) => {
    return cryptoInstance.get(`/pay/${params.module}/wechat/h5/sign`, {
        baseURL: payApi2,
        params: query
    });
};
export const getAliPaySign = ({ params, query }) => {
    return cryptoInstance.get(`/pay/${params.module}/alipay/h5/sign`, {
        baseURL: payApi2,
        params: query
    });
};
// APP 唤起微信支付宝支付
export const getAppPaySign = (params, query) => {
    return cryptoInstance.get(`/pay/${params.module}/${params.platform}/${params.type}/sign`, {
        baseURL: payApi2,
        params: query
    });
};
// 订单详情
export const getOrderDetail = (params) => {
    return cryptoInstance.get(`/pay/order/settlement`, { baseURL, params });
};
// 获取订单信息
export const getOrderMsg = (params) => {
    return cryptoInstance.get(`/pay/order/settlementBehalf`, { params, baseURL });
};
// 获取优惠券列表
export const getCouponList = (params) => {
    return cryptoInstance.get(`/pay/order/coupon/getList`, { baseURL, params });
};
// 更新选择优惠券
export const updateCoupon = (params) => {
    return cryptoInstance.get(`/pay/order/coupon/updateOrderCoupon`, {
        baseURL,
        params
    });
};
// 获取订单支付状态
export const getOrderStatus = (type, orderId) => {
    return cryptoInstance.get(`/pay_status/${type}/${orderId}`, {
        baseURL
    });
};
// 订单是否支付
export const getPayStatus = (orderId) => {
    return cryptoInstance.get(`/pay_status/vip/${orderId}`, { baseURL });
};
